/* eslint-disable max-classes-per-file */
/* eslint-disable @typescript-eslint/naming-convention */

import type { CardInfoInterface } from "@/app/[lang]/hotels/components/HotelSearchComponent/HotelSearchDestinationContentComponent/HotelSearchDestinationContentClass";

export class DestinationPresenter implements CardInfoInterface {
  imageForCard: string = "";

  displayNameForCard: string = "";

  cityName: string = "";

  countryId: number = 0;

  countryName: string = "";

  cssClass: string = "";

  destinationId: number = 0;

  displayName: string = "";

  id: string = "";

  imgIcon: string = "";

  keywordId: number = 0;

  language: string = "";

  latitude: string = "0";

  locationId: number | null = null;

  longitude: string = "0";

  slug: string = "";

  sort: string = "0";

  tableSlug: string = "";

  tableSlugText: string = "";

  totalCount: number = 0;

  countrySlug: string = "";

  citySlug: string = "";

  areaSlug: string = "";

  hotelSlugPath: string = "";

  cityId?: number;

  constructor(data: any) {
    this.imageForCard = data.imageForCard || "";
    this.displayNameForCard = data.displayNameForCard || "";
    this.cityId = data.cityId !== undefined ? Number(data.cityId) : undefined;
    this.cityName = data.cityName || "";
    this.countryId = Number(data.countryId || 0);
    this.countryName = data.countryName || "";
    this.cssClass = data.cssClass || "";
    this.destinationId = Number(data.destinationId || 0);
    this.displayName = data.displayName || "";
    this.id = data.id || "";
    this.imgIcon = data.imgIcon || "";
    this.keywordId = Number(data.keywordId || 0);
    this.language = data.language || "";
    this.latitude = data.latitude || "0";
    this.locationId = data.locationId ?? null;
    this.longitude = data.longitude || "0";
    this.slug = data.slug || "";
    this.sort = data.sort || "0";
    this.tableSlug = data.tableSlug || "";
    this.tableSlugText = data.tableSlugText || "";
    this.totalCount = Number(data.totalCount || 0);
    this.countrySlug = data.countrySlug || "";
    this.citySlug = data.citySlug || "";
    this.areaSlug = data.areaSlug || "";
    this.hotelSlugPath = data.hotelSlugPath || "";
  }
}

export class ResponseTouristInThailand {
  destinations: DestinationPresenter[] = [];

  constructor(data: any) {
    if (Array.isArray(data)) {
      this.destinations = data.map((item) => new DestinationPresenter(item));
    } else {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn(
          "Expected an array for DestinationListPresenter, but got:",
          typeof data,
        );
      }
      this.destinations = [];
    }
  }
}
